<template>
  <section class="uploadWordPage">
    <popup v-show="isShowUploadWord" bread="教材管理,课程管理,设置主题资料,上传video" title="上传video" @onBack="popup_back">
      <template slot="button">
        <el-button type="success" @click="saveUploadWord">保存并上传</el-button>
      </template>
      <infoUpDown :bread="'上传video'">
        <h3 class="group-tit">video资料</h3>
        <commonUploadVideo
          ref="ref_commonUploadWord"
          :key="timestamp"
          :max-number="(30-currentNumber)"
          code="dc"
          :label-name="'视频'"
          :add-or-edit="'add'"
          @formChange="commonUploadWordChange"
        />
      </infoUpDown>
    </popup>
  </section>
</template>

<script>
import commonUploadVideo from '../components/commonUploadVideo'
import { addBasicMeans } from '@api/courseManagement/api_setThemeData'
export default {
  components: {
    commonUploadVideo
  },
  props: {
    currentNumber: {
      type: Number,
      default: 0
    },
    addOrEdit: {
      type: String,
      default: 'add'
    },
    timestamp: {
      type: Number,
      default: 0
    },
    themeRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isShowUploadWord: false,
      commonUploadForm: {}
    }
  },
  watch: {
    timestamp: function (val) {
      this.isShowUploadWord = true
    }
  },
  created () {
    console.log(this.addOrEdit)
  },
  methods: {
    // 返回
    popup_back () {
      this.isShowUploadWord = false
      // this.$emit('resetFetchData')
    },
    commonUploadWordChange (form) {
      this.commonUploadForm = form
    },
    async saveUploadWord () {
      if (!this.$refs.ref_commonUploadWord.validateForm()) {
        this.$message.error('请正确填写信息')
        return false
      }
      const params = []
      for (const item of this.commonUploadForm.wordList) {
        params.push({
          wordName: item.wordName,
          cardChartName: item.img[0].paramsFileName,
          cardChartPath: item.img[0].paramsUrl,
          mouthShapeName: item.video[0].paramsFileName,
          mouthShapePath: item.video[0].paramsUrl,
          teachingThemeId: this.themeRow.id,
          meansType: 10,
          basicCode: 'VIDEO',
          isUse: '0'
        })
      }
      console.log(params)
      try {
        await Promise.all(params.map(async (item) => {
          // 等待异步操作完成，返回执行结果
          return await addBasicMeans({ basicMeansList: [item] })
        }))

        this.$message.success('添加成功')
        this.isShowUploadWord = false
        this.$emit('resetFetchData')
      } catch (e) {
        console.log(e)
      }
    }

  }
}
</script>

<style lang='scss'>
.uploadWordPage{
  .group-tit{
    margin: 24px 0;color:#53402B;display: flex;
    align-items: center;
    span{color: #898884;}
    &::before{
      content: '';
      width: 6px;
      height: 22px;
      display: inline-block;
      background: #FCDA6F;
      margin-right: 8px;
      border-radius: 9px;
    }
  }
}
.upload-form-self{
  display: flex;
  flex-wrap: wrap;
  .el-form-item{
    width: 40%;
    &:nth-child(odd){
      margin-right: 10%;
    }
  }
}
</style>
